// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__WDZHf","vLegacy":"SelectSecondary_vLegacy__3ujgr","error":"SelectSecondary_error__w7sO9","disabled":"SelectSecondary_disabled__9hq7J"};